<ng-container>
    <div class="container">
        <ng-container *ngIf="alertvarService.legendState">
            <div class="legend mt-3 span-m primary-text">
                <div class="legend-item" *ngFor="let legend of legends">
                    <div class="marker">
                        <ng-container *ngFor="let item of legend.color;  first as f">
                            <div class="legend-color icon-m radius-round" [style.backgroundColor]="item" *ngIf="f"></div>
                            <!-- <ng-container *ngIf="!f">
                                <span class="legend-dash"></span>
                                <div class="legend-color" [style.backgroundColor]="item"></div>
                            </ng-container> -->
                        </ng-container>
                    </div>
                    <div class="legend-label">{{ legend.label }} </div>

                    <!-- <span *ngIf="legend.showCnt">({{alertvarService.alertSummaryCountDetails[legend.value]}})</span> -->
                    <span *ngIf="legend.showCnt && legend.value=='has_alerts'">({{alertvarService.rootNodeEpisodesCount}})</span>
                    <span *ngIf="legend.showCnt && legend.value=='has_no_alerts'">({{ get_total_episode_count('Episodes
                        in Time Range')}})</span>

                    <!-- <span *ngIf="legend.showCnt && legend.value=='has_no_alerts' && alertvarService.overviewDetails.length>0 && get_total_episode_count('Episodes in Time Range')">({{alertvarService.overviewDetails[1]['Episodes in Time Range']-alertvarService.rootNodeEpisodesCount}})</span> -->
                    <!-- <span *ngIf="legend.showCnt && legend.value=='has_no_alerts' && alertvarService.overviewDetails.length==0 && !alertvarService.overviewDetails[1]['Episodes in Time Range']">(0)</span> -->



                    <!-- alertvarservice.overviewDetails[1]['Episodes in Time Range']-alertvarservice.rootNodeEpisodesCount -->

                </div>
            </div>
        </ng-container>
        <svg class="connector">
            <rect id="exploration-zoom-pan-canvas"></rect>
            <g transform="translate(100,300)" id="exploration-graph">
                <g class="links"></g>
                <g class="nodes"></g>
            </g>
        </svg>
        <!-- <div class="svg-tooltip">
            <div class="content">
                <div class="value"></div>
                <div class="count"></div>
                <div class="percent"></div>
            </div>
        </div> -->
        <div class="svg-tooltip  white-bg dropdown-shadow p-2 span-m radius-s primary-text">
            <div class="content">
                <div class="value"></div>
                <div class="value2"></div>

                <div class="count">
                    <span class="count-key">
                        Count:
                    </span>
                    <span class="count-value">

                    </span>
                </div>
                <div class="percent">
                    <span class="percent-key">
                        Percentage:
                    </span>
                    <span class="percent-value">

                    </span>
                </div>
            </div>
        </div>
        <div class="header-wrapper">
            <!-- widget details header-->
            <!-- <ng-container *ngIf="widgetDetail != null && widgetDetail !=undefined"> -->
            <div class="header-col-2 ">

                <div class="more-option">
                    <div class="more-option-container radius-s span-m primary-text white-bg border-light-left" [ngClass]="moreOptionState ? 'more-option-tools':'more-option-close'">


                        <!-- <div [ngClass]="moreOptionState?'option-expand':'option-close'"> -->
                        <div class="icon-div enable-action" #legendOptionOrigin>
                            <img src="assets/alerts/legend-outline.svg" (click)="showLegend()" tooltip="Legend" [ngClass]="alertvarService.legendState?'legend-enabled tooltip-enable':'legend-disabled tooltip-enable'">
                        </div>
                        <div class="icon-div" [ngClass]="isAction? 'disable-action':'enable-action'" #platformOrigin>
                            <img (click)="alertvarService.openAdvancedFilter(platformOrigin,0,isAction)" src="assets/alerts/clock.svg" tooltip="Time Filter" class="tooltip-enable">
                        </div>
                        <div class="icon-div" [ngClass]="isAction? 'disable-action':'enable-action'" #templateOptionOrigin>
                            <img src="assets/alerts/template-outline.svg" class="tooltip-enable" (click)="openOverlay_templates(templateRef,templateOptionOrigin)" tooltip="Templates">
                        </div>
                        <div class="icon-div" [ngClass]="isAction? 'disable-action':'enable-action'">
                            <img class="refresh tooltip-enable" src="assets/widgets/refresh.svg" (click)="reset()" tooltip="Reset">
                        </div>
                        <div class="icon-div enable-action">
                            <img src="assets/alerts/center.svg" (click)="alertvarService.centerAlign()" tooltip="Center" class="tooltip-enable">
                        </div>
                        <!-- <div class="icon-div" #visualizeOptionOrigin>
                            <img src="assets/widgets/basic_line.svg"
                                (click)="openOverlay_preview(visualizeRef,visualizeOptionOrigin)" tooltip="visualize">
                        </div> -->

                        <!-- </div> -->
                    </div>
                    <div #moreOptionOrigin class="close-div py-2 px-3 white-bg border-light radius-s" (click)="openOverlay_moreoptions_click(moreOptionRef,moreOptionOrigin)">
                        <!-- <img  *ngIf="!moreOptionState" src="assets/widgets/more-options.svg" (click)="moreOptions_click()"
                                (click)="$event.stopPropagation()"> -->
                        <img src="assets/alerts/more-icon.svg" class="more-icon tooltip-enable" [tooltip]="'More'" *ngIf="!moreOptionState">
                        <img class="close-more tooltip-enable" src="assets/alerts/close.svg" [tooltip]="'Close'" *ngIf="moreOptionState">


                    </div>
                </div>
            </div>
            <!-- more options - refresh,download pdf, date filter, full screen and color palatte -->
            <!-- <div class="header-col-2-1" (click)="$event.stopPropagation()"> -->
            <!-- more oprions in template - this is loaded when more oprions is clicked -->

            <!-- </div> -->
            <!-- </ng-container> -->
            <!-- <ng-container *ngIf="errorhandledashboardwidget.status">
            <div></div>
            <div class="dashboard-refresh">
                <img src="assets/widgets/refresh.svg" class="enable-action" [tooltip]="moreoptiontitles[1]"
                    (click)="load_widgetData('refresh',loginService.metaData.dashboard.dateFilter_default.default_fromDt,'refresh')">
            </div>
        </ng-container> -->

        </div>
    </div>
</ng-container>

<ng-container *ngIf="alertvarService.alertactionmanagement.progress.chartprogress">

    <div class="chart-container-spinner primary=bg">
        <div class="loading">
            <mat-spinner class="spinner" diameter=20></mat-spinner>
        </div>
        <div>
            <!-- <button class=" radius-s cancel" (click)="cancel_relationChart()">Cancel</button> -->
            <button class=" radius-s cancel" (click)="cancel_relationChart()">{{alertvarService.titles.relationChartTitles.cancel}}</button>
        </div>
    </div>
</ng-container>

<ng-template #relationList>
    <div class="relation-option-container  white-bg dropdown-shadow span-l px-3 radius-m primary-text bold-text">
        <div class="heading  white-bg lightest-text border-light-bottom">
            <img class="has-icon tooltip-enable legend-enabled" src="assets/alerts/equal-to.svg" alt="has-entity" tooltip="Has">
            <img class="hasnot-icon tooltip-enable px-0 py-4" src="assets/alerts/notequal-to.svg" alt="hasnot-entity" tooltip="Has not">

            <img class="hasnot-icon tooltip-enable px-0 py-4" src="assets/alerts/timeline.svg" alt="timeline-entity" tooltip="Time bucket">

            <img class="hasnot-icon tooltip-enable px-0 py-4" src="assets/alerts/severity.svg" alt="severity-entity" tooltip="Volume">
            <img class="remove-entity-icon-enable tooltip-enable px-0 py-4" *ngIf="relationist.id!='1'" src="assets/settings/delete.svg" alt="remove-entity" tooltip="Remove" (click)="RemoveNode(relationist)">
            <img class="remove-entity-icon-disable tooltip-enable px-0 py-4" *ngIf="relationist.id == '1'" src="assets/settings/delete.svg" alt="remove-entity" tooltip="Remove">
        </div>
        <div class="sub-heading span-l py-3 border-light-bottom placeholder-text lightest-text primary-text">{{alertvarService.titles.relationChartTitles.choose_target_entity}}</div>
        <ul class="parent-menu p-0 m-0">
            <div>
                <ng-container *ngFor="let item of relationist.target_entity; let i = index">
                    <li>
                        <!-- <span class="entity">{{item.label}}</span> -->
                        <ul class="relation-menu p-0 m-0" [ngClass]="selectedrelationMenuKey == item.label?'choose-relation-menu primary-bg':''">
                            <ng-container *ngFor="let relation of item.relations; let j =index">
                                <li class="py-3 pl-2" [ngClass]="relation.isEnable?'enable-action ':'disable-action'" id="filter-{{i}}-{{j}}" (mouseover)="openInstantfilterOverlay(i,j,relation,item.label)">
                                    <span>{{item.label}}</span>
                                    <span>&gt;</span>
                                </li>
                            </ng-container>
                        </ul>
                    </li>
                </ng-container>
                <li *ngIf="!relationist.target_entity.length" class="no-relation span-m secondary-text">{{alertvarService.titles.relationChartTitles.no_relations}}</li>
            </div>
        </ul>
    </div>
</ng-template>

<ng-template #instantfilter>
    <div>
        <ul class="filter-menu white-bg dropdown-shadow radius-m m-0 p-3">

            <div class="heading  pb-3 border-light-bottom placeholder-text lighter-text">{{alertvarService.titles.relationChartTitles.instant_filter}}</div>
            <div class="filter-menu-container content-m bold-text">
                <ng-container *ngFor="let filter of instantFilterOption">
                    <li class="py-3 pl-2 enable-action" *ngIf="filter.isEnable" (click)="addNode(filter,relationist)">
                        <span>{{filter.label}}</span>
                    </li>
                    <li class="py-3 pl-2 disable-action" *ngIf="!filter.isEnable">
                        <span>{{filter.label}}</span>
                    </li>
                </ng-container>
            </div>
        </ul>
    </div>
</ng-template>
<!-- parent,child overlay -->
<!-- <ng-template #relationList>
    <div class="relation-option-container" >
        <div class="heading">Target entity</div>
        <ul class="parent-menu">
            <div>
                <ng-container *ngFor="let item of relationist.target_entity; let i = index">
                    <li>
                        <span class="entity">{{item.label}}</span>
                        <ul class="relation-menu" >
                            <ng-container *ngFor="let relation of item.relations; let j =index">
                                <li [ngClass]="relation.isEnable?'enable-action':'disable-action'" id="filter-{{i}}-{{j}}" (mouseover)="openInstantfilterOverlay(i,j,relation.instantFilter)" >
                                    <span>{{relation.label}}</span>
                                    <span>&gt;</span>
                                    <ng-template #instantfilter>
                                        <ul class="filter-menu" (mouseleave)="closeInstantfilterOverlay()">
                                        
                                            <div class="heading">Instant Filter</div>
                                            <div class="filter-menu-container" >
                                                <ng-container *ngFor="let filter of instantFilterOption">
                                                    <li class="enable-action" *ngIf="filter.isEnable"
                                                        (click)="addNode(relation,item,filter,relationist)">
                                                        <span>{{filter.label}}</span>
                                                    </li>
                                                    <li class="disable-action" *ngIf="!filter.isEnable">
                                                        <span>{{filter.label}}</span>
                                                    </li>
                                                </ng-container>
                                            </div>
                                        </ul>
                                    </ng-template>
                                </li>
                            </ng-container>
                        </ul>
                    </li>
                </ng-container>
                <li *ngIf="!relationist.target_entity.length" class="no-relation">no relations</li>
            </div>
        </ul>
    </div>
</ng-template> -->



<!-- <ng-template #relationList>
    <div class="relation-option-container" (mouseleave)="closeAllMenus()">
        <div class="heading">Target entity</div>
        <ul class="parent-menu">
            <div>
                <ng-container *ngFor="let item of relationist.target_entity; let i = index">
                    <li>
                        <span class="entity">{{item.label}}</span>
                        <ul class="relation-menu">
                            <ng-container *ngFor="let relation of item.relations; let j =index">
                                <li [ngClass]="relation.isEnable?'enable-action':'disable-action'" id="filter-{{i}}-{{j}}" (mouseenter)="toggleMenu($event, 'child-'+i+j,relation.instantFilter)">
                                    <span  >{{relation.label}}</span>
                                    <span>&gt;</span>
                                    <ng-template #instantfilter>
                                        <ul class="filter-menu">
                                        
                                            <div class="heading">Instant Filter</div>
                                            <div class="filter-menu-container">
                                                <ng-container *ngFor="let filter of instantFilterOption">
                                                    <li class="enable-action" *ngIf="filter.isEnable"
                                                        (click)="addNode(relation,item,filter,relationist)" >
                                                        <span>{{filter.label}}</span>
                                                    </li>
                                                    <li class="disable-action" *ngIf="!filter.isEnable" >
                                                        <span>{{filter.label}}</span>
                                                    </li>
                                                </ng-container>
                                            </div>
                                        </ul>
                                    </ng-template>
                                </li>
                            </ng-container>
                        </ul>
                    </li>
                </ng-container>
                <li *ngIf="!relationist.target_entity.length" class="no-relation">no relations</li>
            </div>
        </ul>
    </div>
</ng-template> -->

<ng-template #contextList>
    <div class="context-option-container white-bg dropdown-shadow px-1 py-2 span-l radius-m primary-text bold-text">
        <ul class="parent-menu ">
            <li (click)="RemoveNode(relationist)">{{alertvarService.titles.relationChartTitles.remove}}</li>
        </ul>
    </div>
</ng-template>

<ng-template #moreOptionRef>
    <!-- *ngIf="moreOptionState" (click)="$event.stopPropagation()" -->
    <!-- <div class="more-option">
        <div class="more-option-container">
            <div class="icon-div">
                <img src="assets/widgets/refresh.svg" (click)="clearSvg()" tooltip="clear">
            </div>
            <div class="icon-div templates" #templateOptionOrigin>
                <img src="assets/alerts/share-solid.svg"
                    (click)="openOverlay_templates(templateRef,templateOptionOrigin)" tooltip="templates">
            </div>
            <div class="icon-div" #visualizeOptionOrigin>
                <img src="assets/widgets/filter.svg" (click)="openOverlay_preview(visualizeRef,visualizeOptionOrigin)"
                    tooltip="preview">
            </div>

        </div>
    </div> -->
</ng-template>


<ng-template #templateRef>
    <div class="template-option-container white-bg dropdown-shadow px-1 py-2 span-l radius-m primary-text bold-text">
        <ul class="parent-menu p-0 m-0">
            <ng-container *ngFor="let item of alertvarService.templates; let i = index">
                <li class="pl-3 py-3" (click)="changeTemplate(item)">{{item.label}}</li>
            </ng-container>
        </ul>
    </div>
</ng-template>

<ng-template #legendRef>
    <div class="legend-container">
        <!-- <div class="legend-header"> Chart Legend
          
        </div> -->

        <!-- <div class="legend-section"> -->
        <div class="legend-item" *ngFor="let legend of legends">
            <div class="legend-color icon-m" [style.backgroundColor]="legend.color"></div>
            <div class="legend-label">{{ legend.label }}</div>
        </div>
    </div>
    <!-- </div> -->
</ng-template>


<ng-template #visualizeRef>
    <div class="previewContainer">
        <!-- <img src="assets/alerts/bar-chart-675.png">
        <div class="placeholder">
            <h1 class="content">Placeholder</h1>
        </div> -->
        <div echarts [options]="chartOption" class="chart" id="nodeChart"></div>
    </div>
</ng-template>